<template>
  <div v-show="innerShouldShow">Display Image</div>
</template>

<script>
import formMixin from "../formMixin";

export default {
  name: 'TypeDisplayImage',
  mixins: [formMixin],
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  }
}
</script>
